import React from 'react';

import i18n from '@components/i18n/i18n';
import { FieldWrap, FieldMessages, FieldLabel, FieldError } from '../common';
import { FieldSelect } from './Select.styles';
import FieldRequiredLabel from '@components/Form/CountrySelect/FieldRequiredLabel';

const Select = ({
  id,
  name,
  label,
  register,
  errors,
  field,
  children,
  dark = false,
  required = false,
  disabled = false,
  ...rest
}) => {
  const language = i18n.language;
  const dir = i18n.dir();

  return (
    <FieldWrap>
      <FieldMessages>
        <FieldLabel htmlFor={id} dark={!!dark} disabled={disabled}>
          {label}
          {required && <FieldRequiredLabel />}
        </FieldLabel>
        {errors && errors[field.name] && (
          <FieldError>{errors[field.name]}</FieldError>
        )}
      </FieldMessages>
      <FieldSelect
        id={id}
        className={[language, dir].join(' ')}
        name={name}
        ref={register}
        disabled={disabled}
        error={errors && errors[field.name] ? true : false}
        dark={!!dark}
        {...field}
        {...rest}
      >
        {children}
      </FieldSelect>
    </FieldWrap>
  );
};

export default Select;
